(function () {
  function closeModal(root) {
    var dialog = root.querySelector('[data-wbs-sus-modal]');
    if (!dialog || !dialog.open) return;
    var video = dialog.querySelector('video');
    var iframe = dialog.querySelector('iframe');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (iframe) iframe.removeAttribute('src');
    document.documentElement.removeAttribute('scroll-lock');
    dialog.close();
  }

  function openModal(root) {
    var dialog = root.querySelector('[data-wbs-sus-modal]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    dialog.showModal();
    document.documentElement.setAttribute('scroll-lock', '');
    var video = dialog.querySelector('video');
    if (video) {
      var play = video.play();
      if (play && play.catch) {
        play.catch(function () {
          video.muted = true;
          video.play();
        });
      }
    }
  }

  function init(root) {
    if (root.dataset.wbsSusReady === 'true') return;
    root.dataset.wbsSusReady = 'true';

    root.querySelectorAll('[data-wbs-sus-open-film]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(root);
      });
    });

    var dialog = root.querySelector('[data-wbs-sus-modal]');
    if (!dialog) return;

    root.querySelectorAll('[data-wbs-sus-close-film]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(root);
      });
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal(root);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeModal(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-wbs-sustainability]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wbs-sustainability]');
    if (!root && event.target.matches && event.target.matches('[data-wbs-sustainability]')) {
      root = event.target;
    }
    if (root) init(root);
  });
})();
